import distributions from "./Distributions";
import apps from "./Apps";
import snapshot from "./Snapshot";
import backups from "./Backups";
import upload from "./Upload";

export default { distributions, apps, snapshot, backups, upload };
